import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { UpcomingProject } from '../types';
import UpcomingProjectCard from './UpcomingProjectCard';

interface UpcomingSectionProps {
  projects: UpcomingProject[];
  onProjectClick?: (project: UpcomingProject) => void;
}

export const UpcomingSection: React.FC<UpcomingSectionProps> = ({ projects, onProjectClick }) => {
  if (projects.length === 0) return null;
  return (
    <Box sx={{ mb: 4 }}>
      <Typography
        variant="h6"
        sx={{
          fontWeight: 700,
          mb: 2,
          color: 'var(--color-accent)',
          fontSize: { xs: '1rem', sm: '1.25rem' },
        }}
      >
        Upcoming
      </Typography>
      <Grid container spacing={3}>
        {projects.map((p) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={p.id}>
            <UpcomingProjectCard project={p} onClick={onProjectClick} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default UpcomingSection;
